export default __webpack_public_path__ + "static/media/mechanic.cd724046.png";